import CONST from './Constant';

const createInitialState = () => ({
    inputCode: '',
    outputCode: '',
    codeType: '',
});

const INITIAL_STATE = createInitialState();

const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONST.RESET:
            return createInitialState();
        case CONST.UPDATE_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case CONST.UPDATE_INPUT_CODE:
            return {
                ...state,
                inputCode: action.payload,
            };
        case CONST.UPDATE_OUTPUT_CODE:
            return {
                ...state,
                outputCode: action.payload,
            };
        case CONST.UPDATE_CODE_TYPE:
            return {
                ...state,
                codeType: action.payload,
            };
        default:
            return state;
    }
};

export default Reducer;

